export default "__VITE_ASSET__8$I8JuVg__"